export const TRANSLATION_KEYS = {
    Heading: "reportPage.heading",
    SecondaryHeading: "reportPage.secondaryHeading",
    FiltersHeading: "common.refinementsDrawer.heading",
    WidgetAllHeading: "reportPage.widgetAllHeading",
    WidgetAllTooltip: "reportPage.widgetAllTooltip",
    WidgetOpenHeading: "reportPage.widgetOpenHeading",
    WidgetOpenTooltip: "reportPage.widgetOpenTooltip",
    WidgetPendingHeading: "reportPage.widgetPendingHeading",
    WidgetPendingTooltip: "reportPage.widgetPendingTooltip",
    WidgetWorkingHeading: "reportPage.widgetWorkingHeading",
    WidgetWorkingTooltip: "reportPage.widgetWorkingTooltip",
    WidgetClosedHeading: "reportPage.widgetClosedHeading",
    WidgetClosedTooltip: "reportPage.widgetClosedTooltip",
    WidgetCanceledHeading: "reportPage.widgetCanceledHeading",
    WidgetCanceledTooltip: "reportPage.widgetCanceledTooltip",
    WidgetDeletedHeading: "reportPage.widgetDeletedHeading",
    WidgetDeletedTooltip: "reportPage.widgetDeletedTooltip",
    ChartOpenLabel: "reportPage.chartOpenLabel",
    ChartPendingLabel: "reportPage.chartPendingLabel",
    ChartWorkingLabel: "reportPage.chartWorkingLabel",
    ChartClosedLabel: "reportPage.chartClosedLabel",
    ChartCanceledLabel: "reportPage.chartCanceledLabel",
    ChartDeletedLabel: "reportPage.chartDeletedLabel",
    ApplyText: "common.applyText",
    ClearText: "common.clearText",
    FromDateLabel: "reportPage.reportCriteria.fromDateLabel",
    FromDatePlaceholder: "reportPage.reportCriteria.fromDatePlaceholder",
    ToDateLabel: "reportPage.reportCriteria.toDateLabel",
    ToDatePlaceholder: "reportPage.reportCriteria.toDatePlaceholder",
    AreaLabel: "ticketDetailsPage.detailsForm.areaLabel",
    AreaPlaceholder: "ticketDetailsPage.detailsForm.areaPlaceholder",
    DepartmentLabel: "reportPage.reportCriteria.departmentLabel",
    DepartmentPlaceholder: "reportPage.reportCriteria.departmentPlaceholder",
    AgentLabel: "reportPage.reportCriteria.agentLabel",
    AgentPlaceholder: "reportPage.reportCriteria.agentPlaceholder",
    ComboPlaceholder: "ticketDetailsPage.detailsForm.comboPlaceholder",
    DatePlaceholder: "ticketDetailsPage.detailsForm.datePlaceholder",
    InputPlaceholder: "ticketDetailsPage.detailsForm.inputPlaceholder",
};